import { ROUTE_BY_PRODUCT } from './productOfferingCtas.mjs';

export const LANDING_COPY_FIELDS = [
  'chipLabel',
  'name',
  'hookBefore',
  'hookAfter',
  'hookHighlight',
  'body',
  'ctaLabel',
  'howLabel',
];

const CHIP_ICONS = new Set(['toy', 'book', 'clapperboard', 'sparkles']);
const VIDEO_BY_PRODUCT = {
  toy: 'R_homepage.webm',
  story: 'U_homepage.webm',
  animation: 'B_homepage.webm',
};
const CHIP_BY_PRODUCT = {
  toy: 'toy',
  story: 'book',
  animation: 'clapperboard',
};
const MASCOT_BY_PRODUCT = {
  toy: 'riko',
  story: 'umi',
  animation: 'bibi',
};
const STORAGE =
  'https://hdtgqbtxmtvridkxsjcd.supabase.co/storage/v1/object/public/demo/Website';

function isCompleteLocale(value) {
  return (
    value != null &&
    typeof value === 'object' &&
    LANDING_COPY_FIELDS.every(
      (field) => typeof value[field] === 'string' && value[field].trim().length > 0,
    )
  );
}

export function isCompleteLandingHero(value) {
  return (
    value != null &&
    typeof value === 'object' &&
    Number.isInteger(value.sortOrder) &&
    CHIP_ICONS.has(value.chipIcon) &&
    isCompleteLocale(value.fa) &&
    isCompleteLocale(value.en)
  );
}

export function mergeLandingSlides(classicRows, publishedServices) {
  const locked = classicRows
    .filter((row) =>
      Object.prototype.hasOwnProperty.call(ROUTE_BY_PRODUCT, row.productType),
    )
    .map((row) => ({
      id: row.productType,
      kind: 'locked',
      productType: row.productType,
      sortOrder: row.sortOrder,
      tieBreak: 0,
      href: ROUTE_BY_PRODUCT[row.productType],
      navName: String(row.name ?? '').trim(),
      navNameEn:
        row.nameEn == null ? null : String(row.nameEn).trim() || null,
      video: `${STORAGE}/${VIDEO_BY_PRODUCT[row.productType]}`,
      chipIcon: CHIP_BY_PRODUCT[row.productType],
      mascot: MASCOT_BY_PRODUCT[row.productType],
    }));

  const custom = publishedServices
    .filter(
      (row) =>
        typeof row.slug === 'string' &&
        row.slug.trim().length > 0 &&
        typeof row.landingVideoUrl === 'string' &&
        /^https?:\/\//i.test(row.landingVideoUrl.trim()) &&
        isCompleteLandingHero(row.landingHero),
    )
    .map((row) => ({
      id: row.slug.trim(),
      kind: 'custom',
      sortOrder: row.landingHero.sortOrder,
      tieBreak: 1,
      href: `/s/${encodeURIComponent(row.slug.trim())}?new=true`,
      navName: String(row.name ?? row.slug).trim(),
      video: row.landingVideoUrl.trim(),
      chipIcon: row.landingHero.chipIcon,
      copy: {
        fa: row.landingHero.fa,
        en: row.landingHero.en,
      },
    }));

  return [...locked, ...custom].sort(
    (a, b) => a.sortOrder - b.sortOrder || a.tieBreak - b.tieBreak,
  );
}
